import { API_URL } from '../../constants';
import { getRequest } from '../../utils/requestService';
import { TUserGroup } from '../../../spa/store/models/types';
import { getDispatch } from '../../../spa/store';

const USER_GROUPS_URL = API_URL + '/groups';

export const fetchUserGroups = (): Promise<TUserGroup[]> => {
  const dispatch = getDispatch();
  return dispatch(getRequest(USER_GROUPS_URL));
};
